var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
export var AssignmentRequestKindEnum;
(function (AssignmentRequestKindEnum) {
    AssignmentRequestKindEnum["Drill"] = "DRILL";
    AssignmentRequestKindEnum["Note"] = "NOTE";
    AssignmentRequestKindEnum["Chart"] = "CHART";
    AssignmentRequestKindEnum["Appdesigner"] = "APPDESIGNER";
    AssignmentRequestKindEnum["SubmissionBox"] = "SUBMISSION_BOX";
    AssignmentRequestKindEnum["Moral"] = "MORAL";
    AssignmentRequestKindEnum["Block"] = "BLOCK";
    AssignmentRequestKindEnum["Keyboard"] = "KEYBOARD";
    AssignmentRequestKindEnum["Work"] = "WORK";
})(AssignmentRequestKindEnum || (AssignmentRequestKindEnum = {}));
export var AssignmentResponseKindEnum;
(function (AssignmentResponseKindEnum) {
    AssignmentResponseKindEnum["Drill"] = "DRILL";
    AssignmentResponseKindEnum["Note"] = "NOTE";
    AssignmentResponseKindEnum["Chart"] = "CHART";
    AssignmentResponseKindEnum["Appdesigner"] = "APPDESIGNER";
    AssignmentResponseKindEnum["SubmissionBox"] = "SUBMISSION_BOX";
    AssignmentResponseKindEnum["Moral"] = "MORAL";
    AssignmentResponseKindEnum["Block"] = "BLOCK";
    AssignmentResponseKindEnum["Keyboard"] = "KEYBOARD";
    AssignmentResponseKindEnum["Work"] = "WORK";
})(AssignmentResponseKindEnum || (AssignmentResponseKindEnum = {}));
export var AssignmentResponseStateEnum;
(function (AssignmentResponseStateEnum) {
    AssignmentResponseStateEnum["Distributed"] = "DISTRIBUTED";
    AssignmentResponseStateEnum["Draft"] = "DRAFT";
    AssignmentResponseStateEnum["DistributionProcess"] = "DISTRIBUTION_PROCESS";
    AssignmentResponseStateEnum["CreationProcess"] = "CREATION_PROCESS";
})(AssignmentResponseStateEnum || (AssignmentResponseStateEnum = {}));
export var ContentRequestKindEnum;
(function (ContentRequestKindEnum) {
    ContentRequestKindEnum["Drill"] = "DRILL";
    ContentRequestKindEnum["Note"] = "NOTE";
    ContentRequestKindEnum["Chart"] = "CHART";
    ContentRequestKindEnum["Appdesigner"] = "APPDESIGNER";
    ContentRequestKindEnum["SubmissionBox"] = "SUBMISSION_BOX";
    ContentRequestKindEnum["Moral"] = "MORAL";
    ContentRequestKindEnum["Block"] = "BLOCK";
    ContentRequestKindEnum["Keyboard"] = "KEYBOARD";
    ContentRequestKindEnum["Work"] = "WORK";
})(ContentRequestKindEnum || (ContentRequestKindEnum = {}));
export const AssignmentControllerApiAxiosParamCreator = function (configuration) {
    return {
        deleteAssignmentsId: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('deleteAssignmentsId', 'id', id);
            const localVarPath = `/assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAssignments: (type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAssignments', 'type', type);
            const localVarPath = `/assignments`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            if (srcUserIds) {
                localVarQueryParameter['srcUserIds'] = srcUserIds;
            }
            if (destUserIds) {
                localVarQueryParameter['destUserIds'] = destUserIds;
            }
            if (operator !== undefined) {
                localVarQueryParameter['operator'] = operator;
            }
            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }
            if (distributedFrom !== undefined) {
                localVarQueryParameter['distributedFrom'] = distributedFrom;
            }
            if (distributedTo !== undefined) {
                localVarQueryParameter['distributedTo'] = distributedTo;
            }
            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        getAssignmentsId: (id, skipThumbnail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getAssignmentsId', 'id', id);
            const localVarPath = `/assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (skipThumbnail !== undefined) {
                localVarQueryParameter['skipThumbnail'] = skipThumbnail;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        postAssignmentsDist: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('postAssignmentsDist', 'id', id);
            const localVarPath = `/assignments/{id}/dist`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        postAssignmentsDraft: (assignmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('postAssignmentsDraft', 'assignmentRequest', assignmentRequest);
            const localVarPath = `/assignments/draft`;
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        putAssignmentsId: (id, assignmentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('putAssignmentsId', 'id', id);
            assertParamExists('putAssignmentsId', 'assignmentRequest', assignmentRequest);
            const localVarPath = `/assignments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AssignmentControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AssignmentControllerApiAxiosParamCreator(configuration);
    return {
        deleteAssignmentsId(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAssignmentsId(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getAssignments(type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssignments(type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        getAssignmentsId(id, skipThumbnail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAssignmentsId(id, skipThumbnail, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        postAssignmentsDist(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postAssignmentsDist(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        postAssignmentsDraft(assignmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postAssignmentsDraft(assignmentRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        putAssignmentsId(id, assignmentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putAssignmentsId(id, assignmentRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const AssignmentControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AssignmentControllerApiFp(configuration);
    return {
        deleteAssignmentsId(id, options) {
            return localVarFp.deleteAssignmentsId(id, options).then((request) => request(axios, basePath));
        },
        getAssignments(type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options) {
            return localVarFp.getAssignments(type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options).then((request) => request(axios, basePath));
        },
        getAssignmentsId(id, skipThumbnail, options) {
            return localVarFp.getAssignmentsId(id, skipThumbnail, options).then((request) => request(axios, basePath));
        },
        postAssignmentsDist(id, options) {
            return localVarFp.postAssignmentsDist(id, options).then((request) => request(axios, basePath));
        },
        postAssignmentsDraft(assignmentRequest, options) {
            return localVarFp.postAssignmentsDraft(assignmentRequest, options).then((request) => request(axios, basePath));
        },
        putAssignmentsId(id, assignmentRequest, options) {
            return localVarFp.putAssignmentsId(id, assignmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class AssignmentControllerApi extends BaseAPI {
    deleteAssignmentsId(id, options) {
        return AssignmentControllerApiFp(this.configuration).deleteAssignmentsId(id, options).then((request) => request(this.axios, this.basePath));
    }
    getAssignments(type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options) {
        return AssignmentControllerApiFp(this.configuration).getAssignments(type, page, size, sort, order, srcUserIds, destUserIds, operator, title, distributedFrom, distributedTo, kind, options).then((request) => request(this.axios, this.basePath));
    }
    getAssignmentsId(id, skipThumbnail, options) {
        return AssignmentControllerApiFp(this.configuration).getAssignmentsId(id, skipThumbnail, options).then((request) => request(this.axios, this.basePath));
    }
    postAssignmentsDist(id, options) {
        return AssignmentControllerApiFp(this.configuration).postAssignmentsDist(id, options).then((request) => request(this.axios, this.basePath));
    }
    postAssignmentsDraft(assignmentRequest, options) {
        return AssignmentControllerApiFp(this.configuration).postAssignmentsDraft(assignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
    putAssignmentsId(id, assignmentRequest, options) {
        return AssignmentControllerApiFp(this.configuration).putAssignmentsId(id, assignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
export const AssignmentInternalControllerApiAxiosParamCreator = function (configuration) {
    return {
        getCallback: (id, state, cloudId, schoolId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('getCallback', 'id', id);
            assertParamExists('getCallback', 'state', state);
            assertParamExists('getCallback', 'cloudId', cloudId);
            assertParamExists('getCallback', 'schoolId', schoolId);
            const localVarPath = `/internal/assignments/async/result/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (cloudId !== undefined) {
                localVarQueryParameter['cloudId'] = cloudId;
            }
            if (schoolId !== undefined) {
                localVarQueryParameter['schoolId'] = schoolId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        putContentsId: (id, contentRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            assertParamExists('putContentsId', 'id', id);
            assertParamExists('putContentsId', 'contentRequest', contentRequest);
            const localVarPath = `/internal/assignments/{id}/contents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(contentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
export const AssignmentInternalControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AssignmentInternalControllerApiAxiosParamCreator(configuration);
    return {
        getCallback(id, state, cloudId, schoolId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCallback(id, state, cloudId, schoolId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        putContentsId(id, contentRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putContentsId(id, contentRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
export const AssignmentInternalControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AssignmentInternalControllerApiFp(configuration);
    return {
        getCallback(id, state, cloudId, schoolId, options) {
            return localVarFp.getCallback(id, state, cloudId, schoolId, options).then((request) => request(axios, basePath));
        },
        putContentsId(id, contentRequest, options) {
            return localVarFp.putContentsId(id, contentRequest, options).then((request) => request(axios, basePath));
        },
    };
};
export class AssignmentInternalControllerApi extends BaseAPI {
    getCallback(id, state, cloudId, schoolId, options) {
        return AssignmentInternalControllerApiFp(this.configuration).getCallback(id, state, cloudId, schoolId, options).then((request) => request(this.axios, this.basePath));
    }
    putContentsId(id, contentRequest, options) {
        return AssignmentInternalControllerApiFp(this.configuration).putContentsId(id, contentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map